import axios from 'axios';
import { useContext } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import ThemeProvider from './theme';

import { AuthContext } from './components/Context/Auth/auth.context';
import routes from './routes';

// ----------------------------------------------------------------------
import jwtDecode from 'jwt-decode';
import { AppContext } from './components/Context/AppContext/app.context';

function isLoggedIn() {
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }
  const decoded = jwtDecode(token);
  const expires = new Date(decoded.exp * 1000);
  if (expires < new Date()) {
    localStorage.clear();
    navigate('/login');
    return false;
  }
  return true;
}
export default function App() {
  const checkToken = isLoggedIn();
  const navigate = useNavigate();
  let {
    authState: { isAuthenticated, name, userRole, firstPasswordChanged },
  } = useContext(AuthContext);
  let { fetchEmployersAndClients, dataFetched } = useContext(AppContext);
  //console.log('firstPasswordChanged:', firstPasswordChanged);
  const routing = useRoutes(routes(isAuthenticated, name, userRole, firstPasswordChanged));
  // Redirect to Login on 401 response
  axios.interceptors.response.use(
    (response) => {
      //console.log('respones::::', response.status);
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        localStorage.clear();
        navigate('/login');
      }
      return Promise.reject(error);
    }
  );

  if (!dataFetched && isAuthenticated) {
    console.log('Rerenderd');
  }
  return (
    <ThemeProvider>
      {/* <Notification /> */}
      <ScrollToTop />
      <StyledChart />
      {/* <Router/> */}
      {routing}
    </ThemeProvider>
  );
}
